<h4 *ngIf="networkService.getCurrentNetworkStatus() == 1">Celular sem conexão de internet</h4>